import ColorThemeController from './ColorThemeController';
/**
 * Registers a color theme directive with the provided module.
 * 
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerColorThemeDirective(angular) {
    // SMELL: Using a string for the directive name can lead to typos and is not refactor-friendly. Consider using a constant or a variable.
    angular.module('assessmentFrontendDirectives').directive('colorTheme', function() {
        return {
            restrict: 'E', // Restricts the directive to be used as an element only.
            replace: true, // Replaces the HTML element with the template.
            templateUrl: '/views/ib/components/colorTheme/ColorThemeDirective.html', // Path to the directive's template.
            controller: ColorThemeController // The controller associated with the directive.
        };
    });
}